import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_301: DocMigration = {
  maxSchemaVersion: "0.0.301",
  description: "porch column patterns from static room layout to room.",
  apply(json: any): any {
    const roomEdgeBehaviors: { [id: string]: any } = {};
    let count = Object.keys(json.roomEdgeBehaviors).length;
    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      if (!staticRoomLayout) {
        continue;
      }

      const porchColumnPatterns = staticRoomLayout?.porchColumnPatterns;
      if (!porchColumnPatterns?.length) {
        // I realize this can orphan empty arrays, but staticRoomLayout will get removed in 8th and final migration of this set.
        continue;
      }

      for (const porchColumnPattern of porchColumnPatterns) {
        const id = uid();
        roomEdgeBehaviors[id] = {
          ...porchColumnPattern,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "PORCH_COLUMN",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.porchColumnPatterns;
    }

    json.roomEdgeBehaviors = { ...json.roomEdgeBehaviors, ...roomEdgeBehaviors };
    return json;
  },
};

export default migration_0_0_301;
